import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import Raven from 'raven-js';
import { useState } from 'react';
import { HUBSPOT_CREDITS_CARD } from '../../v2/constants/tracking/TrackingSources';
import { TalkToSalesFallback } from '../../features/purchaseMotions/components/TalkToSalesFallback';
import { useCalculatedPrice } from '../../hooks/useBulkPurchaseOptions';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { highestPackagedQuantityForByUnitNameFromProductInventorySelector, productsFromProductInventoryQuantitySelector } from '../../selectors/ProductInventorySelectors';
import { billingNameKeySelector, packagedQuantityBySkuIdSelector, productForSkuIdSelector, unitNameForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { queryParamTermSelector } from '../../selectors/QueryParamTermSelectors';
import { CustomError } from '../../v2/components/error-boundary/CustomErrors';
import { ErrorBoundary } from '../../v2/components/error-boundary/ErrorBoundary';
import { AddOnCardCTA } from './AddOnCardCTA';
import AddOnCardLayoutUI from './AddOnCardLayoutUI';
import { CardLayoutAlert } from './CardLayoutAlert';
import { jsx as _jsx } from "react/jsx-runtime";
export const HubSpotCreditsCard = ({
  screen,
  skuId
}) => {
  const ownedQuantity = useAppSelector(state => productsFromProductInventoryQuantitySelector(state, {
    skuId
  }));
  const [selectedQuantity, setSelectedQuantity] = useState(0);
  const unitName = useAppSelector(state => unitNameForSkuIdSelector(state, {
    skuId
  }));
  const packagedQuantities = useAppSelector(state => {
    var _packagedQuantityBySk;
    return unitName ? (_packagedQuantityBySk = packagedQuantityBySkuIdSelector(state, {
      skuId,
      unitName
    })) !== null && _packagedQuantityBySk !== void 0 ? _packagedQuantityBySk : 1 : 1;
  });
  const includeDefaultHubspotCredits = useAppSelector(state => unitName ? highestPackagedQuantityForByUnitNameFromProductInventorySelector(state, {
    unitName
  }) : 0);
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const queryParamTerm = useAppSelector(queryParamTermSelector);
  const productConfigurations = [createProductConfig({
    skuId,
    quantity: selectedQuantity === 0 ? 1 : selectedQuantity + ownedQuantity
  })];
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  const currencyCode = useDisplayedCurrencyCode();
  const {
    monthlyCalculatedPrice,
    error
  } = useCalculatedPrice({
    apiName: product.apiName,
    queryParamTerm
  });
  if (!monthlyCalculatedPrice) {
    Raven.captureException(new CustomError('No pricing data found for product', {
      error
    }));
    return null;
  }
  return /*#__PURE__*/_jsx(AddOnCardLayoutUI, {
    "data-test-id": `${HUBSPOT_CREDITS_CARD}-${product.apiName}`,
    "data-selenium-id": `${HUBSPOT_CREDITS_CARD}-${product.apiName}`,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages-ui.productNamesV2.${billingNameKey}.title`
    }),
    pricing: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "priceDisplay.highlightedPrice.pricePerCredits",
      options: {
        price: /*#__PURE__*/_jsx("span", {
          "data-selenium-id": `${HUBSPOT_CREDITS_CARD}-${product.apiName}-price`,
          children: /*#__PURE__*/_jsx(PriceDisplay, {
            price: monthlyCalculatedPrice,
            currencyCode: currencyCode
          })
        }),
        packagedQuantities
      }
    }),
    cta: /*#__PURE__*/_jsx(ErrorBoundary, {
      fallback: /*#__PURE__*/_jsx(TalkToSalesFallback, {
        apiName: product.apiName,
        trackingSource: HUBSPOT_CREDITS_CARD,
        screen: screen
      }),
      children: /*#__PURE__*/_jsx(AddOnCardCTA, {
        skuId: skuId,
        screen: screen,
        trackingSource: HUBSPOT_CREDITS_CARD,
        term: queryParamTerm,
        selectedQuantity: selectedQuantity,
        packagedQuantities: packagedQuantities,
        ownedQuantity: ownedQuantity,
        productConfigurations: productConfigurations,
        onQuantityChange: setSelectedQuantity
      })
    }),
    description: /*#__PURE__*/_jsx(Text, {
      typography: "body-100",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "touchless-buying-components.hubSpotCredits.description"
      })
    }),
    alert: /*#__PURE__*/_jsx(CardLayoutAlert, {
      packagedQuantities: packagedQuantities,
      ownedQuantity: ownedQuantity,
      isHubSpotCredits: true,
      includedDefaultUnits: includeDefaultHubspotCredits,
      titleString: I18n.text(`pricing-pages-ui.productNamesV2.${billingNameKey}.title`)
    })
  });
};
export default HubSpotCreditsCard;